import axios from 'axios';
import * as storage from './storage';
import { equalsIgnoringCase } from './utils';
import jwt_decode from 'jwt-decode';
import services from '.';
import { Header } from 'antd/lib/layout/layout';
import globals from '../globals';

const CancelToken = axios.CancelToken;
let cancel;

axios.interceptors.request.use(
  async function (config) {
    // Do something before request is sent
    let newConfig = {};
    if (config) {
      newConfig = config;
    }

    try {
      if (
        newConfig.url.startsWith(globals.REACT_APP_APIROOT_AUTO) &&
        !newConfig.url.endsWith('login')
        //&& !newConfig.url.endsWith('publico-detalhe')
      ) {
        let tokenData = storage.get('authSistema');
        let captcha = storage.get('captcha');

        if (tokenData?.token) {
          let decoded = jwt_decode(tokenData.token);
          let isExpired = _isExpired(decoded.exp);

          if (isExpired) {
            services.storage.clear();
            window.location.href = '/';
            //history.push(`/`)
            // re logar user
            // let retLogin = await logar()
            // if (retLogin.data) {
            //     tokenData =  storage.get('authAgenda')
            //     decoded = jwt_decode(tokenData.token)
            //     isExpired = _isExpired(decoded.exp)
            // } else {
            //     //useHistory.push(`/error`)
            //     services.storage.clear()
            //     throw new Error('Erro ao autenticar')
            // }
          }

          newConfig.headers = {
            ...newConfig.headers,
            Authorization: `Bearer ${tokenData.token}`,
          };
        } else {
          newConfig.headers = {
            ...newConfig.headers,
            captcha: captcha,
          };
        }
      }
      return newConfig;
    } catch (error) {
      throw error;
    }
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
const _sendWithAxiosAssunto = async (url, method, payload) => {
  try {
    const result = await axios({
      url: url,
      method: method,
      data: payload,
    });
    if (url) return { data: result, fail: null };
    return { data: result.data, fail: null };
  } catch (error) {
 
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};

const _isExpired = (dataEx) => {
  let dataExformat = dataEx * 1000;
  if (Date.now() >= dataExformat) {
    return true;
  }
  return false;
};

const _sendWithAxios = async (url, method, payload) => {
  try {
    const result = await axios({
      url: url,
      method: method,
      data: payload,
    });
    if (url.startsWith(globals.REACT_APP_APIADRESS))
      return { data: result.data, fail: null };
    return { data: result.data.data, fail: null };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};

const _sendWithAxiosFale = async (url, method, payload) => {
  if (cancel != undefined) {
    cancel();
  }
  try {
    const result = await axios({
      url: url,
      method: method,
      data: payload,
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    });
    return { data: result, fail: null, status: result.status };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};
const _sendWithAxiosCancelPrev = async (url, method, payload) => {
  if (cancel != undefined) {
    cancel();
  }
  try {
    const result = await axios({
      url: url,
      method: method,
      data: payload,
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    });
    return { data: result.data.data, fail: null, status: result.status };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};

const _sendWithAxiosBlob = async (url, method, payload) => {
  try {
    const result = await axios({
      url: url,
      method: method,
      responseType: 'blob',
      data: payload,
    });
    return { data: result.data, fail: null };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};

const _parseError = (error) => {
  let errors = [];
  const { response, isAxiosError } = error;
  if (response && response.data) {
    const { data } = response;
    errors = data || [];
  } else if (isAxiosError) {
    errors.push({ message: 'Falha ao enviar dados ao servidor' });
  }
  return errors;
};

////// geral

export const searchCpf = async (params) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}usuario/existe`,
    'POST',
    params
  );
};
////// Acesso espelho

export const acessoEspelho = async (params) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}login/espelho`,
    'POST',
    params
  );
};

////// cotatos
export const assuntoListagem = async () => {
  return await _sendWithAxiosAssunto(
    `${globals.REACT_APP_APIROOT_AUTO}fale-conosco/assuntos`,
    'GET'
  );
};
export const faleConoscoListagem = async (
  page = 1,
  assunto = '',
  email = '',
  telefone = ''
) => {
  let params = new URLSearchParams({
    page: page,
    pageSize: 10,
    Telefone: telefone,
    Email: email,
    Assunto: assunto,
  });

  return await _sendWithAxiosFale(
    `${globals.REACT_APP_APIROOT_AUTO}fale-conosco/listar?${params.toString()}`,
    'GET'
  );
};
export const faleConoscoId = async (id) => {
  return await _sendWithAxiosFale(
    `${globals.REACT_APP_APIROOT_AUTO}fale-conosco/${id}`,
    'GET'
  );
};
export const getAssuntoFaleConosco = async () => {
  return await _sendWithAxiosAssunto(
    `${globals.REACT_APP_APIROOT_AUTO}fale-conosco/assuntos`,
    'GET'
  );
};
export const contatosFinalizados = async (page = 1, busca = '') => {
  let obj = {
    page: page,
    pageSize: 10,
    query: busca,
  };
  return await _sendWithAxiosCancelPrev(
    `${globals.REACT_APP_APIROOT_AUTO}fale-conosco/finalizados`,
    'POST',
    obj
  );
};
export const contatoDetalhe = async (contatoId) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}fale-conosco/${contatoId}`,
    'GET'
  );
};
export const contatoEnviarMsg = async (faleConoscoAssuntoId, msg) => {
  let obj = {
    faleConoscoAssuntoId: faleConoscoAssuntoId,
    mensagem: msg,
  };
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}fale-conosco/enviar-mensagem`,
    'POST',
    obj
  );
};
export const contatoEncerrar = async (faleConoscoAssuntoId) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}fale-conosco/${faleConoscoAssuntoId}/encerrar`,
    'POST',
    {}
  );
};
export const contatoCriar = async (descricao, mensagem) => {
  let obj = {
    descricao: descricao,
    mensagens: {
      mensagem: mensagem,
    },
  };
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}fale-conosco`,
    'POST',
    obj
  );
};

////// administrador
export const obterAdminstradores = async (page, busca = '') => {
  let obj = {
    page: page,
    pageSize: 10,
    query: busca,
  };
  return await _sendWithAxiosCancelPrev(
    `${globals.REACT_APP_APIROOT_AUTO}administrador/filtrar`,
    'POST',
    obj
  );
};
export const adminstradorDetalhe = async (id) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}administrador/${id}`,
    'GET'
  );
};

export const adminstradorCriar = async (admin) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}administrador`,
    'POST',
    admin
  );
};
export const adminstradorEditar = async (id, admin) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}administrador/${id}`,
    'PUT',
    admin
  );
};
export const adminstradorAtivarInativar = async (id) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}usuario/${id}/AtivarInativar`,
    'POST',
    {}
  );
};
export const adminstradorExportar = async () => {
  return await _sendWithAxiosBlob(
    `${globals.REACT_APP_APIROOT_AUTO}administrador/exportar`,
    'GET'
  );
};

/////// empresas
export const obterEmpresas = async (page, busca = '') => {
  let obj = {
    page: page,
    pageSize: 10,
    query: busca,
  };
  return await _sendWithAxiosCancelPrev(
    `${globals.REACT_APP_APIROOT_AUTO}empresa/filtrar`,
    'POST',
    obj
  );
};
export const obterRecrutadoresPorEmpresas = async (page, id) => {
  let obj = {
    page: page,
    pageSize: 10,
  };
  return await _sendWithAxiosCancelPrev(
    `${globals.REACT_APP_APIROOT_AUTO}empresa/${id}/recrutadores`,
    'POST',
    obj
  );
};
export const empresaAll = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}empresa/lista-simplificada`,
    'GET'
  );
};
export const empresaDetalhe = async (id) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}empresa/${id}`,
    'GET'
  );
};
export const empresaAtivarInativar = async (id, status) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}empresa/${id}/${status}`,
    'PUT',
    {}
  );
};
export const empresaCriar = async (admin) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}empresa`,
    'POST',
    admin
  );
};
export const empresaEditar = async (id, admin) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}empresa/${id}`,
    'PUT',
    admin
  );
};
export const empresasExportar = async () => {
  return await _sendWithAxiosBlob(
    `${globals.REACT_APP_APIROOT_AUTO}empresa/exportar`,
    'GET'
  );
};
export const empresasUploadImg = async (file) => {
  const data = new FormData();
  data.append('file', file);
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}upload/logo-empresa`,
    'POST',
    data
  );
};

/////// candidatos
export const obterCandidatos = async (page, busca = '') => {
  let obj = {
    page: page,
    pageSize: 10,
    query: busca,
  };
  return await _sendWithAxiosCancelPrev(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/filtrar`,
    'POST',
    obj
  );
};
export const candidatoMinhasVagas = async (page, busca = '') => {
  let obj = {
    page: page,
    pageSize: 10,
    query: busca,
  };
  return await _sendWithAxiosCancelPrev(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/minhas-vagas`,
    'POST',
    obj
  );
};
export const candidatoExportar = async () => {
  return await _sendWithAxiosBlob(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/exportar`,
    'GET'
  );
};
export const candidatoDetalhe = async (id) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/${id}`,
    'GET'
  );
};
export const candidatoDetalheVisaoRecrutador = async (id) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/candidatura/${id}/visao-recrutador`,
    'GET'
  );
};
export const candidatoDetalheAgenda = async (id) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/candidatura/${id}/detalhe-agenda`,
    'GET'
  );
};
export const candidatoCriar = async (candidato) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/cadastro-admin`,
    'POST',
    candidato
  );
};
export const candidatoEditar = async (id, candidato) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/${id}`,
    'PUT',
    candidato
  );
};
export const candidatoAtivarInativar = async (id, status) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/${id}/${status}`,
    'PUT',
    {}
  );
};
export const obterCandidaturasByCandidato = async (page, idCandidato) => {
  let obj = {
    page: page,
    pageSize: 10,
  };
  return await _sendWithAxiosCancelPrev(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/${idCandidato}/historico-candidaturas`,
    'POST',
    obj
  );
};
export const candidatoDetalheCandidatura = async (candidatoVagaId) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/candidatura/${candidatoVagaId}`,
    'GET'
  );
};
export const candidatoUploadCurriculo = async (file) => {
  const data = new FormData();
  data.append('file', file);
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}upload/curriculos-candidatos`,
    'POST',
    data
  );
};
export const candidatoPreCadastro = async (candidato) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}candidato`,
    'POST',
    candidato
  );
};
export const candidatoEditarMeusDados = async (candidato) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/meu-cadastro`,
    'PUT',
    candidato
  );
};
export const salvarCandidatura = async (candidato, id) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/candidatura/${id}`,
    'PUT',
    candidato
  );
};

/////// endereços
export const enderecoEstados = async () => {
  return await _sendWithAxios(`${globals.REACT_APP_APIROOT_AUTO}estado`, 'GET');
};
export const enderecoEndByCep = async (cep) => {
  let value = cep.replace(/\-/g, '');
  return await _sendWithAxios(
    `${globals.REACT_APP_APIADRESS}cep/${value}`,
    'GET'
  );
};
export const enderecoCidades = async (ufId) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}cidade/${ufId}`,
    'GET'
  );
};

////////////// vagas
export const obterVagas = async (page, busca = '') => {
  let obj = {
    page: page,
    pageSize: 10,
    query: busca,
  };
  return await _sendWithAxiosCancelPrev(
    `${globals.REACT_APP_APIROOT_AUTO}vaga/filtrar`,
    'POST',
    obj
  );
};
export const obterVagasBusca = async (page, busca = '') => {
  let obj = {
    page: page,
    pageSize: 10,
    query: busca,
  };
  return await _sendWithAxiosCancelPrev(
    `${globals.REACT_APP_APIROOT_AUTO}vaga/publico-lista`,
    'POST',
    obj
  );
};
export const obterVagasPorEmpresa = async (page, busca = '') => {
  let obj = {
    page: page,
    pageSize: 10,
    query: busca,
  };
  return await _sendWithAxiosCancelPrev(
    `${globals.REACT_APP_APIROOT_AUTO}vaga/filtrar-por-empresa`,
    'POST',
    obj
  );
};
export const vagasExportar = async () => {
  return await _sendWithAxiosBlob(
    `${globals.REACT_APP_APIROOT_AUTO}vaga/exportar`,
    'GET'
  );
};
export const meCandidatar = async (vagaId, data) => {
  let objEnvio = {
    vagaId: vagaId,
    agendas: {
      dataAgendamento: data,
    },
  };
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/me-candidatar`,
    'POST',
    objEnvio
  );
};

export const vagasDetalhe = async (id) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}vaga/${id}`,
    'GET'
  );
};
export const vagasDisponivel = async (id) => {
  //return await _sendWithAxiosBlob(`${globals.REACT_APP_APIROOT_AUTO}vaga/exportar`, 'GET')
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}vaga/${id}/publico-detalhe`,
    'GET'
  );
};
export const vagasEditar = async (id, vaga) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}vaga/${id}`,
    'PUT',
    vaga
  );
};
export const vagasCriar = async (vaga) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}vaga`,
    'POST',
    vaga
  );
};
export const vagasDetalheCandidatos = async (idVaga, page) => {
  let obj = {
    page: page,
    pageSize: 10,
  };
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}vaga/${idVaga}/candidatos`,
    'POST',
    obj
  );
};

//////////// outros
export const tiposContratacao = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}tipo-contratacao`,
    'GET'
  );
};
export const tiposAnuncio = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}tipo-anuncio`,
    'GET'
  );
};
export const statusProcessoVaga = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}status-processo-vaga`,
    'GET'
  );
};
export const statusProcessoVagaNova = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}status-processo-vaga/nova-vaga`,
    'GET'
  );
};
export const statusProcessoCandidato = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}status-processo-candidato`,
    'GET'
  );
};
export const modelosTrabalho = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}modelo-trabalho`,
    'GET'
  );
};
export const idiomas = async () => {
  return await _sendWithAxios(`${globals.REACT_APP_APIROOT_AUTO}idioma`, 'GET');
};
export const idiomaFluencias = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}fluencia-idioma`,
    'GET'
  );
};
export const niveisHierarquicosVaga = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}nivel-hierarquico-vaga`,
    'GET'
  );
};
export const getMeuCadastroRecrutador = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}recrutador/meu-cadastro`,
    'GET'
  );
};
export const getMeuCadastroCandidato = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}candidato/meu-cadastro`,
    'GET'
  );
};
export const getSugestaoPesquisaVaga = async (busca) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}vaga/sugestao-pesquisa/${busca}`,
    'GET'
  );
};
export const buscarEmpresaPorCnpj = async (cnpj) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}empresa/${cnpj}`,
    'GET'
  );
};

///////////////////////////////////////
export const perfis = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}perfis/admin`,
    'GET'
  );
};

export const perfisParticipantes = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}perfis/participantes`,
    'GET'
  );
};

export const perfisAcessoParticipantes = async () => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}perfisAcesso/participantes`,
    'GET'
  );
};

export const logar = async (acessParams) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}login/admin`,
    'POST',
    acessParams
  );
};

export const preCadastro = async (params) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}usuario/precadastro/admin`,
    'POST',
    params
  );
};

export const confirmarResetSenha = async (params) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}usuario/senha/confirmar`,
    'POST',
    params
  );
};

export const resetarSenha = async (email) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}usuario/senha/resetar`,
    'POST',
    email
  );
};

export const saveAcao = async (params) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}acao/novo`,
    method: `POST`,
    data: params,
  }).then((response) => response.data);

  return result;
};

export const saveAdmin = async (params) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}usuario/cadastrar-administrador`,
    method: `POST`,
    data: params,
  });

  return result.data;
};

export const alterAdmin = async (params) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}usuario/alterar-meus-dados`,
    method: `POST`,
    data: params,
  }).then((response) => response.data);

  return result;
};

export const editAcao = async (params) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}acao/editar`,
    method: `POST`,
    data: params,
  }).then((response) => response.data);

  return result;
};

export const saveTreinamento = async (params) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}treinamento`,
    method: `POST`,
    data: params,
  }).then((response) => response.data);

  return result;
};
export const editTreinamento = async (params, id) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}treinamento/editar/${id}`,
    method: `PUT`,
    data: params,
  }).then((response) => response.data);

  return result;
};

export const getRegional = async () => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/regional`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

export const getAcaoList = async (pagina) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}acao/listar/${pagina}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

export const getFilial = async (regional, classificacao) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/filial`,
    method: `POST`,
    data: {
      classificacao: classificacao ? classificacao.toString() : null,
      regional: equalsIgnoringCase(regional, 'TODOS') ? null : regional,
    },
  }).then((response) => response.data);
  return result;
};

export const getCampanhaWithId = async (id) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}acao/buscar/id`,
    method: `POST`,
    data: { id: id },
  }).then((response) => response.data);
  return result;
};

export const getTreinamentoWithId = async (id) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}treinamento/${id}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

export const postEncerrarCampanha = async (id) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}acao/ativar-inativar`,
    method: `POST`,
    data: { id: id },
  }).then((response) => response.data);
  return result;
};
export const postBuscaCampanha = async (nome) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}acao/buscar/nome`,
    method: `POST`,
    data: { nomeAcao: nome },
  }).then((response) => response.data);
  return result;
};

export const postBuscaTreinamento = async (nome) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}treinamento/buscar/nome`,
    method: `POST`,
    data: { NomeTreinamento: nome },
  }).then((response) => response.data);
  return result;
};

export const getParceiros = async (regional, filial) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/acao`,
    method: `POST`,
    data: {
      regional: equalsIgnoringCase(regional, 'Todos') ? null : regional,
      filial: equalsIgnoringCase(filial, 'Todos') ? null : filial,
    },
  }).then((response) => response.data);

  return result;
};

export const getTreinamentos = async (regional, filial) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}treinamento`,
    method: `GET`,
    //data: {
    //  regional: equalsIgnoringCase(regional, 'Todos') ? null : regional,
    //  filial: equalsIgnoringCase(filial, 'Todos') ? null : filial,
    //},
  }).then((response) => response.data);

  return result;
};

export const getCardCampanha = async (pagina) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}acao/cards-campanha/${pagina}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

export const getCardCampanhaData = async (pagina, mes, ano) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}acao/cards-campanha/${pagina}/${mes}/${ano}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

export const getTipoRelatorio = async (pagina) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}tipo-relatorio`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

export const getRelatorio = async (data) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}relatorio`,
    method: `POST`,
    data: data,
    responseType: 'blob',
  });

  return result;
};

export const getListaParceirosAcao = async (idAcao, pesquisa, pagina = 1) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}acao/parceiro-acao-pesquisar`,
    method: `POST`,
    data: {
      idAcao: idAcao,
      pesquisa: pesquisa,
      pagina: pagina,
    },
  }).then((response) => response.data);

  return result;
};

export const getListaParceirosTreinamento = async (
  idTreinamento,
  pesquisa,
  pagina = 1
) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}treinamento/parceiro-treinamento-pesquisar`,
    method: `POST`,
    data: {
      idTreinamento: idTreinamento,
      pesquisa: pesquisa,
      pagina: pagina,
    },
  }).then((response) => response.data);

  return result;
};

export const getListaPerguntasTreinamento = async (
  idTreinamento,
  pesquisa,
  pagina = 1
) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}treinamento/pergunta-treinamento-pesquisar`,
    method: `POST`,
    data: {
      idTreinamento: idTreinamento,
      pesquisa: pesquisa,
      pagina: pagina,
    },
  }).then((response) => response.data);

  return result;
};

export const getDetalhesDesempenho = async (id) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}desempenho/busca-id/${id}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

export const getAcoesPorPeriodo = async (mes, ano) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}acao/listar-nome/periodo/${mes}/${ano}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

export const getRegionalDesempenho = async (idAcao) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/regional/desempenho`,
    method: `POST`,
    data: {
      idAcao: idAcao,
    },
  }).then((response) => response.data);

  return result;
};

export const getFilialDesempenho = async (idAcao, regional) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/filial/desempenho`,
    method: `POST`,
    data: {
      idAcao: idAcao,
      regional: equalsIgnoringCase(regional, 'TODOS') ? null : regional,
    },
  }).then((response) => response.data);

  return result;
};

/* desempenho */
export const getDesempenhoLogImportacao = async (pagina) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}desempenho/log-importacao/${pagina}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

export const getDesempenhoLogStatusResultado = async (idLog, status) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}desempenho/log/${idLog}/${status}`,
    method: `GET`,
    responseType: 'blob',
  }).then((response) => response.data);
  return result;
};

export const getListaAcao = async (data) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}acao/listar-nome/periodo`,
    method: `POST`,
    data: data,
  }).then((response) => response.data);
  return result;
};

export const getListaTreinamento = async () => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}treinamento`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

/**
 * 
 * @param {
    "pagina": 0,
    "idAcao": "string",
    "periodo": "2022-02-09T12:10:57.261Z",
    "regional": "string",
    "filial": "string",
    "tipoParceiro": 0,
    "gerenteRelacionamento": "string"
    } data 
 * @returns 
 */
export const getDesempenhoPesquisa = async (data) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}desempenho/pesquisa`,
    method: `POST`,
    data: data,
  }).then((response) => response.data);
  return result;
};

/*
 * @param form {
 *  IdAcao
 *  PeriodoImportacao
 *  Dados
 * } data
 * @returns
 */
export const postResultados = async (data) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}desempenho/importacao`,
    'POST',
    data
  );
};

/*export const postCadastrarResponsavel = async (data) => {
    return await _sendWithAxios(`${globals.REACT_APP_APIROOT_AUTO}usuario/cadastrar-responsavel`, 'POST', data)
}*/

export const postCadastrarResponsavel = async (params) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}usuario/cadastrar-responsavel`,
    method: `POST`,
    data: params,
  }).then((response) => response.data);

  return result;
};
export const getListaAdmin = async (page) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}usuario/listar-administrador/${page}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};
export const getListaAdminPesquisar = async (pagina, busca) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}usuario/pesquisar-administrador`,
    'POST',
    { pagina: pagina, dadosPesquisa: busca }
  );
};

export const getAdmin = async (id) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}usuario/buscar-administrador/${id}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

export const aproveAdmin = async (id) => {
  try {
    const result = await axios({
      url: `${globals.REACT_APP_APIROOT_AUTO}usuario/ativar-inativar-administrador/${id}`,
      method: `GET`,
    }).then((response) => response.data);
    return { data: result, fail: false };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};
export const getAdminPendente = async () => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}usuario/listagem-admim-pendente`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};
// VITRINE BV

export const getRegionalList = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/regional`,
    method: `GET`,
    params: { classificacaoId: id },
  }).then((response) => response.data);
};

export const getBeneficioList = async (filter) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}vitrine-bv/listar`,
    method: `POST`,
    data: filter,
  }).then((response) => response.data);
};

export const getClassificacaoList = async () => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}classificacao`,
    method: `GET`,
  }).then((response) => response.data);
};

export const getPorteList = async () => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}porte`,
    method: `GET`,
  }).then((response) => response.data);
};

export const getParticipantesList = async (filter) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/participantes/${filter}`,
    method: `GET`,
  }).then((response) => response.data);
};

export const getParticipantesPorFiltroList = async (filter) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}vitrine-bv/filtrar-participantes`,
    method: `POST`,
    data: filter,
  }).then((response) => response.data);
};

export const postVitrineBV = async (objEnvio) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}vitrine-bv`,
    method: `POST`,
    data: objEnvio,
  }).then((response) => response.data);
};

export const putVitrineBV = async (objEnvio) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}vitrine-bv`,
    method: `PUT`,
    data: objEnvio,
  }).then((response) => response.data);
};

export const getVitrineBVById = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}vitrine-bv/${id}`,
    method: `GET`,
  }).then((response) => response.data);
};

export const deleteVitrineBVById = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}vitrine-bv/${id}`,
    method: `DELETE`,
  }).then((response) => response.data);
};

export const getExisteOrdemExibicao = async (ordem) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}vitrine-bv/ordem-exibicao/existe/${ordem}`,
    method: `GET`,
  }).then((response) => response.data);
};

export const getObterOrdemExibicao = async () => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}vitrine-bv/ordem-exibicao/obter`,
    method: `GET`,
  }).then((response) => response.data);
};

export const uploadAnexo = async (file) => {
  const data = new FormData();
  data.append('file', file);
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}upload/conteudo-anexo`,
    'POST',
    data
  );
};

export const postImage = async (file) => {
  const data = new FormData();
  data.append('file', file);
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}upload/bvauto`,
    'POST',
    data
  );
};

export const postResgatar = async (objEnvio) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}vitrine-bv/resgatar`,
    method: `POST`,
    data: objEnvio,
  }).then((response) => response.data);
};
export const getListarResponsavel = async (pagina) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}usuario/listar-responsavel/${pagina}`,
    method: `GET`,
  }).then((response) => response.data);
};

export const getListarResponsavelPesquisar = async (pagina, dadosPesquisa) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}usuario/pesquisar-responsavel`,
    'POST',
    { pagina: pagina, dadosPesquisa: dadosPesquisa }
  );
};
export const getResponsavelById = async (UserId) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}usuario/buscar-responsavel/${UserId}`,
    method: `GET`,
  }).then((response) => response.data);
};

/****** */
export const getImportParceirosLog = async (UserId) => {
  return null; //await axios({ url: `${globals.REACT_APP_APIROOT_AUTO}usuario/buscar-responsavel/${UserId}`, method: `GET` }).then(response => response.data);
};

export const getImportParceirosTreinamentoLog = async (page, idTreinamento) => {
  try {
    const result = await axios({
      url: `${globals.REACT_APP_APIROOT_AUTO}treinamento/log-importacao/${page}/${idTreinamento}`,
      method: 'GET',
    });
    return { data: result.data, fail: null };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }

  //return null; //await axios({ url: `${globals.REACT_APP_APIROOT_AUTO}usuario/buscar-responsavel/${UserId}`, method: `GET` }).then(response => response.data);
  //treinamento/log-importacao/{pagina?}
};

export const getParceirosById = async (ParceiroId) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/buscar-parceiro/${ParceiroId}`,
    method: `GET`,
  }).then((response) => response.data);
};

export const getParceirosByResponsavelId = async function (userId, q, page) {
  var request = { userId, q, page };

  return await axios
    .get(`${globals.REACT_APP_APIROOT_AUTO}parceiro/pdv-responsaveis`, {
      params: request,
    })
    .then(function (response) {
      return response.data.data;
    });
};

export const getParceirosByParticipantesId = async function (userId, q, page) {
  var request = { userId, q, page };

  return await axios
    .get(`${globals.REACT_APP_APIROOT_AUTO}parceiro/pdv-participantes`, {
      params: request,
    })
    .then(function (response) {
      return response.data.data;
    });
};

export const getParticipanteById = async (ParticipanteId) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}usuario/buscar-participante/${ParticipanteId}`,
    method: `GET`,
  }).then((response) => response.data);
};
export const ativarInativarParceirosById = async (ParceiroId) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/ativar-inativar-parceiro/${ParceiroId}`,
    method: `GET`,
  }).then((response) => response.data);
};

export const getParticipantesDeParceirosById = async (UserId) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/participantes/${UserId}`,
    method: `GET`,
  }).then((response) => response.data);
};

export const listarSimplificadaParceiros = async (pagina, buscar) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/listar/${pagina}/${buscar}`,
    method: `GET`,
  }).then((response) => response.data);
};

export const getListaParceirosPesquisar = async (pagina, busca) => {
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}parceiro/pesquisar?pagina=${pagina}&pesquisa=${busca}`,
    'POST'
  );
};

export const listarParceirosGerente = async (page, id, q) => {
  const dados = {
    pagina: page,
    userId: id,
    q: q,
  };
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}parceiro/gerente-relacionamento`,
    'POST',
    dados
  ).then((response) => response.data);
};

export const postParceirosImportacaoExcel = async (data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/parceiroImportacaoExcel`,
    method: `POST`,
    data,
  }).then((response) => response.data);
};

export const postImportParceiros = async (data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/importacao`,
    method: `POST`,
    data,
  }).then((response) => response.data);
};

export const postImportParceirosTreinamento = async (data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}treinamento/importacao`,
    method: `POST`,
    data,
  }).then((response) => response.data);
};

export const postImportParticipantes = async (idPopUp, data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}pop-up/${idPopUp}/importar`,
    method: `POST`,
    data,
  }).then((response) => response.data);
};

export const postParceiros = async (data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/cadastro-parceiro`,
    method: `POST`,
    data,
  }).then((response) => response.data);
};

export const postParticipantes = async (data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}usuario/cadastrar-participante`,
    method: `POST`,
    data,
  }).then((response) => response.data);
};

export const putParticipantesAtivar = async (UserId) => {
  return null; //await axios({ url: `${globals.REACT_APP_APIROOT_AUTO}usuario/buscar-responsavel/${UserId}`, method: `GET` }).then(response => response.data);
};

export const putParticipantesInativar = async (UserId) => {
  return null; //await axios({ url: `${globals.REACT_APP_APIROOT_AUTO}usuario/buscar-responsavel/${UserId}`, method: `GET` }).then(response => response.data);
};

export const getParceiroLogImportacao = async (pagina) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/log-importacao/${pagina}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

export const getParticipanteLogImportacao = async (pagina) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}usuario/log-importacao/${pagina}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};
export const getDestinatariosLogImportacao = async (idPopUp, page = 1, pageSize = 3) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}pop-up/${idPopUp}/importacoes?page=${page}&pageSize=${pageSize}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

export const getLogStatusImportacao = async (idLog, status) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/log-status-importacao/${idLog}/${status}`,
    method: `GET`,
    responseType: 'blob',
  }).then((response) => response.data);
  return result;
};

export const getLogStatusImportacaoParticipantes = async (idPopUp, importacaoId, status, page = 1, pageSize = 10) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}pop-up/${idPopUp}/importacoes/${importacaoId}/detalhes?Page=${page}&PageSize=${pageSize}&Status=${status}`,
    method: `GET`,
    responseType: 'blob',
  }).then((response) => response.data);
  return result;
};

export const getLogStatusTreinamentoImportacaoParticipantes = async (
  idLog,
  status
) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}treinamento/log-status-importacao/${idLog}/${status}`,
    method: `GET`,
    responseType: 'blob',
  }).then((response) => response.data);
  return result;
};

export const getLogStatusImportacaoResultado = async (idLog, status) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}parceiro/log-status-importacao/${idLog}/${status}`,
    method: `GET`,
    responseType: 'blob',
  }).then((response) => response.data);
  return result;
};

export const getResponsavelPdv = async (pagina, UserId) => {
  const dados = {
    pagina: pagina,
    UserId: UserId,
  };
  return null; //await axios({ url: `${globals.REACT_APP_APIROOT_AUTO}usuario/buscar-responsavel/${UserId}`, method: `POST` }).then(response => response.data);
};

export const postBanner = async (data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}banner`,
    method: `POST`,
    data,
  }).then((response) => response.data);
};
export const putBanner = async (data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}banner`,
    method: `PUT`,
    data,
  }).then((response) => response.data);
};
export const deleteBanner = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}banner/Ativar-Inativar/${id}`,
    method: `PUT`,
  }).then((response) => response.data);
};
export const getBannerWithId = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}banner/${id}`,
    method: `get`,
  }).then((response) => response.data);
};
export const getBanner = async (buscar) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}banner?busca=${buscar}`,
    method: `get`,
  }).then((response) => response.data);
};

export const postConteudo = async (data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}conteudo`,
    method: `POST`,
    data,
  }).then((response) => response.data);
};
export const putConteudo = async (data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}conteudo`,
    method: `PUT`,
    data,
  }).then((response) => response.data);
};
export const deleteConteudo = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}conteudo/Ativar-Inativar/${id}`,
    method: `PUT`,
  }).then((response) => response.data);
};
export const getConteudoWithId = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}conteudo/${id}`,
    method: `get`,
  }).then((response) => response.data);
};
export const getConteudo = async (buscar) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}conteudo?busca=${buscar}`,
    method: `get`,
  }).then((response) => response.data);
};

export const postNoticias = async (data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}noticia`,
    method: `POST`,
    data,
  }).then((response) => response.data);
};
export const putNoticias = async (data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}noticia`,
    method: `PUT`,
    data,
  }).then((response) => response.data);
};
export const deleteNoticia = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}noticia/Ativar-Inativar/${id}`,
    method: `PUT`,
  }).then((response) => response.data);
};
export const getNoticiasWithId = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}noticia/${id}`,
    method: `get`,
  }).then((response) => response.data);
};
export const getNoticias = async (buscar) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}noticia?busca=${buscar}`,
    method: `get`,
  }).then((response) => response.data);
};

//api/v1/parceiro/pdv-responsaveis

// ======= QUIZ ======

export const getQuizList = async (filter) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}quiz/listar`,
    method: 'POST',
    data: filter,
  }).then((response) => response.data);
};

export const postQuiz = async (objEnvio) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}quiz`,
    method: 'POST',
    data: objEnvio,
  }).then((response) => response.data);
};

export const putQuiz = async (id, objEnvio) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}quiz/${id}`,
    method: 'PUT',
    data: objEnvio,
  }).then((response) => response.data);
};

export const getQuizById = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}quiz/${id}`,
    method: 'GET',
  }).then((response) => response.data);
};

export const getResultados = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}quiz/${id}/resultados`,
    method: 'GET',
  }).then((response) => response.data);
};

// ======= FAQ ======

export const getFaqList = async (filter) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}faq/listar`,
    method: 'POST',
    data: filter,
  }).then((response) => response.data);
};

export const postFaq = async (objEnvio) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}faq`,
    method: 'POST',
    data: objEnvio,
  }).then((response) => response.data);
};

export const putFaq = async (id, objEnvio) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}faq/${id}`,
    method: 'PUT',
    data: objEnvio,
  }).then((response) => response.data);
};

export const getFaqById = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}faq/${id}`,
    method: 'GET',
  }).then((response) => response.data);
};

export const getSequenciaFaq = async () => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}faq/ordem-sequencia-faq`,
    method: 'GET',
  }).then((response) => response.data);
};

export const inativarFaq = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}faq/${id}`,
    method: 'DELETE',
  }).then((response) => response.data);
};

// ======= REGULAMENTO ======

export const getRegulamentoList = async (filter) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}regulamentos/listar`,
    method: 'POST',
    data: filter,
  }).then((response) => response.data);
};

export const postRegulamento = async (objEnvio) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}regulamentos`,
    method: 'POST',
    data: objEnvio,
  }).then((response) => response.data);
};

export const getRegulamentoById = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}regulamentos/${id}`,
    method: 'GET',
  }).then((response) => response.data);
};

export const getRegulamentoAtivo = async () => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}regulamentos/ativo`,
    method: 'GET',
  }).then((response) => response.data);
};

export const getBanners = async () => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}banner/home`,
    method: 'GET',
  }).then((response) => response.data);
};
export const getMenu = async (guid) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}Menus/${guid}`,
    method: `GET`,
  }).then((response) => response.data);
  return result;
};

// ======= POP-UP ======

export const getPopUpList = async (filter) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}pop-up/listar`,
    method: 'POST',
    data: filter,
  }).then((response) => response.data);
};

export const postPopUp = async (objEnvio) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}pop-up`,
    method: 'POST',
    data: objEnvio,
  }).then((response) => response.data);
};

export const putPopUp = async (id, objEnvio) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}pop-up/${id}`,
    method: 'PUT',
    data: objEnvio,
  }).then((response) => response.data);
};

export const getPopUpUpload = async (file) => {
  const data = new FormData();
  data.append('file', file);
  return await _sendWithAxios(
    `${globals.REACT_APP_APIROOT_AUTO}upload/popup`,
    'POST',
    data
  );
};

export const getPopUpById = async (id) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}pop-up/${id}`,
    method: 'GET',
  }).then((response) => response.data);
};

export const getPopUpStatus = async () => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}pop-up/status`,
    method: 'GET',
  }).then((response) => response.data);
};

export const postPopUpImportacaoExcel = async (data) => {
  return await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}pop-up/importacao`,
    method: `POST`,
    data,
    timeout: 300000, // 5 minutos em milissegundos
  }).then((response) => response.data);
};

export const getListaParticipantePopUp = async (filter) => {
  const result = await axios({
    url: `${globals.REACT_APP_APIROOT_AUTO}pop-up/pesquisar-participante`,
    method: `POST`,
    data: filter,
  }).then((response) => response.data);

  return result;
};
